import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { getIdToken } from '../tokenHandling/tokenSlice';
import type { RootDispatch, RootState } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<RootDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

const MARKETPLACE_ADMINS = [
    'azure-my-rio-de:664de0f9-6990-445a-8664-8a73de131625', // feona.samson@rio.cloud
    'azure-my-rio-de:7750cb43-4227-4021-aecd-ece1fc64107e', // jan.pfeiffer@rio.cloud
    'azure-my-rio-de:dc583b59-ae42-4f96-9586-97c04990ff1e', // leo.lima@rio.cloud
    'azure-my-rio-de:277da9be-693c-4c21-88e0-f53705a6639b', // pedro.santos@rio.cloud
    'azure-my-rio-de:bd805b7a-b8d8-4a9a-86a2-1fa1c1a87e31', // uros.karic@rio.cloud
    'azure-my-rio-de:mock-user', // local mock user
];

export const useIsMarketplaceAdminUser = () => {
    const user = useAppSelector(getIdToken)?.sub;
    return user ? MARKETPLACE_ADMINS.includes(user) : false;
};
